import { ReportPlayerDialog, reportReasons, reportReasonIdMap } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
import { showSimpleDialog } from './showSimpleDialog.ts';
const mountReportPlayerDialog = mountDialogUIReactComponent(ReportPlayerDialog);
const gameReportedText = {
    key: 'strings:popups.reportPopup.reportedPopupText'
};
const profileReportedText = {
    key: 'strings:popups.reportPopup.success'
};
export function showReportPlayerDialog(playerName, reportActionCallBack, isGame) {
    const reportedPopupText = isGame ? gameReportedText : profileReportedText;
    mountReportPlayerDialog({
        playerName: playerName,
        reasons: reportReasons,
        onReport: (reasonId)=>{
            reportActionCallBack(playerName, reportReasonIdMap.fromReasonId(reasonId));
            showSimpleDialog({
                title: {
                    key: 'strings:popups.reportPopup.reported'
                },
                body: reportedPopupText
            });
        }
    });
}
